//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Check from './Check'

export default {
    components: {
        Check,
    },
    props: {
        title: { type: String, default: null },
        text: { type: String, default: null },
        options: { type: Object, default: () => ({}) },
        relationshipEstablishment: { type: Object, required: true },
    },
    computed: {
        me: function() {
            return this.$store.state.user.me
        },
    },
    mounted() {
        if (this.options.redirect === 'company_feedback') {
            const otherMemberCompany =
                this.relationshipEstablishment.first_member.id === this.me.id
                    ? this.relationshipEstablishment.second_member.company
                    : this.relationshipEstablishment.first_member.company

            if (otherMemberCompany.is_partner) {
                window.location.href = `${process.env.VUE_APP_CLUB_BASE_URL}/companies/details/${otherMemberCompany.slug}/info#recommend`
            }
        }
    },
}
